"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Color = /*#__PURE__*/function () {
  function Color(r, g, b) {
    _classCallCheck(this, Color);
    _defineProperty(this, "rgb", {
      r: 0,
      g: 0,
      b: 0
    });
    _defineProperty(this, "identifier", null);
    this.rgb = {
      r: Color.clamp(r),
      g: Color.clamp(g),
      b: Color.clamp(b)
    };
    this.identifier = this.hex;
  }
  _createClass(Color, [{
    key: "hex",
    get: function get() {
      return Color.rgb2hex(this.rgb);
    }
  }, {
    key: "value",
    get: function get() {
      return this.hex;
    }
  }], [{
    key: "clamp",
    value: function clamp(n) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 255;
      return Math.max(Math.min(max, parseInt(n) || 0), min);
    }
  }, {
    key: "fromRGB",
    value: function fromRGB(_ref) {
      var r = _ref.r,
        g = _ref.g,
        b = _ref.b;
      return new Color(r, g, b);
    }
  }, {
    key: "fromHEX",
    value: function fromHEX(hex) {
      var _Color$hexToRgb = Color.hexToRgb(hex),
        r = _Color$hexToRgb.r,
        g = _Color$hexToRgb.g,
        b = _Color$hexToRgb.b;
      return new Color(r, g, b);
    }
  }, {
    key: "rgb2hex",
    value: function rgb2hex(_ref2) {
      var r = _ref2.r,
        g = _ref2.g,
        b = _ref2.b;
      return "#".concat("00000".concat((r << 16 | g << 8 | b).toString(16)).slice(-6));
    }
  }, {
    key: "hexToRgb",
    value: function hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  }]);
  return Color;
}();
function generatePalette() {
  var numColors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var numShades = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var colors = [];
  for (var r = 1; r <= numColors; r++) {
    var sr = r / numColors * 255;
    for (var g = 1; g <= numColors; g++) {
      var sg = g / numColors * 255;
      for (var b = 1; b <= numColors; b++) {
        var sb = b / numColors * 255;
        var shades = [];
        for (var s = 1; s <= numShades; s++) {
          var a = s / numShades;
          var color = new Color(sr * a, sg * a, sb * a);
          color.label = color.hex;
          shades.push(color);
        }
        colors.push(shades);
      }
    }
  }
  return {
    numColors: numColors,
    numShades: numShades,
    colors: colors
  };
}
var styles = {
  colorPalette: {
    display: 'block',
    '&:after': {
      content: "''",
      clear: 'both',
      display: 'block'
    }
  },
  colorBlock: {
    width: 20,
    height: 20,
    display: 'inline-block',
    "float": 'left',
    boxSizing: 'border-box'
  },
  colorRow: {
    display: 'inline-block',
    "float": 'left'
  }
};
var ColorPalette = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorPalette, _React$Component);
  var _super = _createSuper(ColorPalette);
  function ColorPalette() {
    var _this;
    _classCallCheck(this, ColorPalette);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      return _this.setState(function (_ref3) {
        var show = _ref3.show;
        return {
          show: !show
        };
      });
    });
    return _this;
  }
  _createClass(ColorPalette, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        palette = _this$props.palette,
        onChange = _this$props.onChange,
        classes = _this$props.classes,
        value = _this$props.value;
      var _palette = palette || generatePalette(3, 5);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.toggle
      }, "Color"), this.state.show && /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.colorPalette,
        style: {
          width: styles.colorBlock.width * _palette.numShades
        }
      }, _palette.colors.map(function (colors, c) {
        var width = styles.colorBlock.width * _palette.numShades;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: c,
          className: classes.colorRow,
          style: {
            width: width
          }
        }, colors.map(function (color, ci) {
          var hex = color.hex,
            label = color.label,
            identifier = color.identifier;
          var currentColorValue = (0, _isObject["default"])(value.identifier) ? value.identifier.color : value.identifier;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.colorBlock,
            key: ci,
            style: {
              backgroundColor: hex,
              border: value && currentColorValue === identifier ? '1px solid white' : ''
            },
            title: label,
            onMouseDown: function onMouseDown(evt) {
              evt.preventDefault();
              onChange(evt, color);
            }
          });
        }));
      })));
    }
  }]);
  return ColorPalette;
}(_react["default"].Component);
_defineProperty(ColorPalette, "propTypes", {
  palette: _propTypes["default"].object,
  classes: _propTypes["default"].object,
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func
});
_defineProperty(ColorPalette, "defaultProps", {
  palette: {},
  classes: {},
  value: {}
});
var _default = exports["default"] = (0, _withStyles["default"])(styles, {
  name: 'Designer-ColorPalette'
})(ColorPalette);